/**
 * Search form
 */
 var component_search_form = function(args) {

  // setup args
  var search_form = args.search_form;
  var input = search_form.querySelector('.search-form__input');
  var clear_button = search_form.querySelector('.search-form__clear');

  // validate
  if (!search_form) {
    console.log('Invalid search form');
    return;
  }

  /**
   * Toggle clear button visibility
   */
  function clear_button_visibility() {
    return input.value ? clear_button.classList.add('visible') : clear_button.classList.remove('visible');
  }

  /**
   * Init
   */
  function init() {
    clear_button_visibility();

    // listen to input value changes
    input.addEventListener('input', debounce(() => {
      clear_button_visibility();
    }, 250));

    // clear input field when clicking the clear button
    clear_button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // clear field
      input.value = '';

      // dispatch a backspace keyup event to close searchwp live search results
      input.dispatchEvent(new KeyboardEvent('keyup', { key: 'Backspace' }));

      // hide clear button
      clear_button_visibility();

      // focus back to the input field
      input.focus();
    });

    return;
  }
  init();

  // make the call chainable
  return this;
};
